import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ListAltIcon from '@mui/icons-material/ListAlt';
import InsightsIcon from '@mui/icons-material/Insights';
import SettingsIcon from '@mui/icons-material/Settings';
import HelpIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import BarChartIcon from '@mui/icons-material/BarChart';
import PeopleIcon from '@mui/icons-material/People';
import DescriptionIcon from '@mui/icons-material/Description';
import SecurityIcon from '@mui/icons-material/Security';
import PaymentIcon from '@mui/icons-material/Payment';
import { Link, useLocation } from 'react-router-dom';

// Aktiver Menüpunkt basierend auf dem aktuellen Pfad
const ActiveListItem = ({ to, icon, primary, disabled = false }) => {
  const location = useLocation();
  const active = location.pathname === to || location.pathname.startsWith(`${to}/`);
  
  const listItem = (
    <ListItemButton 
      component={Link} 
      to={disabled ? '#' : to}
      selected={active}
      disabled={disabled}
      sx={{
        opacity: disabled ? 0.6 : 1,
        borderRadius: 1.5,
        mx: 1,
        mb: 0.5,
        position: 'relative',
        overflow: 'hidden',
        '&::before': active ? {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '4px',
          backgroundColor: 'primary.main',
          borderRadius: '0 4px 4px 0'
        } : {},
        '&:hover': {
          backgroundColor: 'rgba(255, 122, 0, 0.08)',
        },
        '&.Mui-selected': {
          backgroundColor: 'rgba(255, 122, 0, 0.12)',
          '&:hover': {
            backgroundColor: 'rgba(255, 122, 0, 0.18)',
          }
        }
      }}
    >
      <ListItemIcon sx={{ 
        color: active ? 'primary.main' : 'text.secondary',
        minWidth: 40
      }}>
        {icon}
      </ListItemIcon>
      <ListItemText 
        primary={primary} 
        primaryTypographyProps={{ 
          fontWeight: active ? 600 : 400,
          color: active ? 'primary.main' : 'text.primary',
          fontSize: '0.95rem'
        }} 
      />
      
      {active && (
        <Box 
          sx={{ 
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: '4px',
            backgroundColor: 'primary.main',
            borderRadius: '4px 0 0 4px',
            display: 'none' // Auskommentiert, um nur links den Indikator zu haben
          }}
        />
      )}
    </ListItemButton>
  );
  
  return disabled ? (
    <Tooltip title="Demnächst verfügbar" placement="right">
      <span>{listItem}</span>
    </Tooltip>
  ) : listItem;
};

export const mainListItems = (
  <React.Fragment>
    <Box sx={{ py: 1 }}>
      <ActiveListItem 
        to="/" 
        icon={<DashboardIcon />} 
        primary="Dashboard" 
      />
      <ActiveListItem 
        to="/request" 
        icon={<AssignmentIcon />} 
        primary="Neue Datenanfrage" 
      />
      <ActiveListItem 
        to="/my-requests" 
        icon={<ListAltIcon />} 
        primary="Meine Anfragen" 
      />
      <ActiveListItem 
        to="/analytics" 
        icon={<InsightsIcon />} 
        primary="Datenanalyse" 
        disabled={true}
      />
      <ActiveListItem 
        to="/hospitals" 
        icon={<LocalHospitalIcon />} 
        primary="Partnerkliniken" 
        disabled={true}
      />
      <ActiveListItem 
        to="/reports" 
        icon={<DescriptionIcon />} 
        primary="Berichte & Ergebnisse"
      />
    </Box>
  </React.Fragment>
);

export const secondaryListItems = (
  <React.Fragment>
    <Box sx={{ py: 1 }}>
      <ActiveListItem 
        to="/billing" 
        icon={<PaymentIcon />} 
        primary="Abrechnung" 
        disabled={true}
      />
      <ActiveListItem 
        to="/team" 
        icon={<PeopleIcon />} 
        primary="Team & Berechtigungen" 
        disabled={true}
      />
      <ActiveListItem 
        to="/data-security" 
        icon={<SecurityIcon />} 
        primary="Datensicherheit" 
        disabled={true}
      />
      <ActiveListItem 
        to="/settings" 
        icon={<SettingsIcon />} 
        primary="Einstellungen" 
      />
      <ActiveListItem 
        to="/help" 
        icon={<HelpIcon />} 
        primary="Hilfe & Support" 
      />
      <ActiveListItem 
        to="/about" 
        icon={<InfoIcon />} 
        primary="Über ARGUS" 
      />
    </Box>
  </React.Fragment>
);
